import { render, staticRenderFns } from "./Resturants.vue?vue&type=template&id=67b31f30"
import script from "./Resturants.vue?vue&type=script&lang=js"
export * from "./Resturants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports